import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./select";

const countries = [
  { code: "SG", name: "Singapore", flag: "🇸🇬", currency: "SGD", timezone: "Asia/Singapore" },
  { code: "US", name: "United States", flag: "🇺🇸", currency: "USD", timezone: "America/New_York" },
  { code: "CA", name: "Canada", flag: "🇨🇦", currency: "CAD", timezone: "America/Toronto" },
  { code: "GB", name: "United Kingdom", flag: "🇬🇧", currency: "GBP", timezone: "Europe/London" },
  { code: "AU", name: "Australia", flag: "🇦🇺", currency: "AUD", timezone: "Australia/Sydney" },
  { code: "DE", name: "Germany", flag: "🇩🇪", currency: "EUR", timezone: "Europe/Berlin" },
  { code: "FR", name: "France", flag: "🇫🇷", currency: "EUR", timezone: "Europe/Paris" },
  { code: "JP", name: "Japan", flag: "🇯🇵", currency: "JPY", timezone: "Asia/Tokyo" },
  { code: "KR", name: "South Korea", flag: "🇰🇷", currency: "KRW", timezone: "Asia/Seoul" },
  { code: "CN", name: "China", flag: "🇨🇳", currency: "CNY", timezone: "Asia/Shanghai" },
  { code: "IN", name: "India", flag: "🇮🇳", currency: "INR", timezone: "Asia/Kolkata" },
  { code: "MY", name: "Malaysia", flag: "🇲🇾", currency: "MYR", timezone: "Asia/Kuala_Lumpur" },
  { code: "TH", name: "Thailand", flag: "🇹🇭", currency: "THB", timezone: "Asia/Bangkok" },
  { code: "ID", name: "Indonesia", flag: "🇮🇩", currency: "IDR", timezone: "Asia/Jakarta" },
  { code: "PH", name: "Philippines", flag: "🇵🇭", currency: "PHP", timezone: "Asia/Manila" },
];

interface CountrySelectProps {
  value: string;
  onValueChange: (value: string) => void;
  onCurrencyChange: (currency: string) => void;
  placeholder?: string;
}

export const CountrySelect: React.FC<CountrySelectProps> = ({
  value,
  onValueChange,
  onCurrencyChange,
  placeholder = "Select country"
}) => {
  const handleCountryChange = (countryCode: string) => {
    const country = countries.find(c => c.code === countryCode);
    if (country) {
      onValueChange(countryCode);
      onCurrencyChange(country.currency);
    }
  };

  return (
    <Select value={value} onValueChange={handleCountryChange}>
      <SelectTrigger>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {countries.map((country) => (
          <SelectItem key={country.code} value={country.code}>
            <div className="flex items-center gap-2">
              <span>{country.flag}</span>
              <span>{country.name}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export { countries };